export { default as HomeDetails } from './HomeDetails';
export { default as HomeBox } from './HomeBox';
export { default as HomeUsers } from './HomeUsers';
export { default as HomeProducts } from './HomeProducts';
export { default as HomeTickets } from './HomeTickets';
export { default as Journalisation } from './Journalisation';
export { default as History } from './History';



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Home/sections/index.js